<template>
  <div class="sidebar">
    <el-menu
      :default-active="onRoutes"
      class="sidebar-el-menu"
      @open="handleOpen"
      @close="handleClose"
      background-color="#eeeeee"
      text-color="#393D49"
      active-text-color="#D2D2D2"
      :collapse="isCollapse"
      unique-opened
      router
    >
      <template v-for="item of items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{item.title}}</span>
            </template>
            <template v-for="subItem of item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{subItem.title}}</template>
                <template v-for="threeItem of subItem.subs">
                  <el-menu-item :index="threeItem.index" :key="threeItem.index">{{threeItem.title}}</el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{subItem.title}}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{item.title}}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "SideBar",
    data() {
        return {

        };
    },
  computed: {
    ...mapState(['isCollapse','user_info', 'userMenus']),
    onRoutes () {
      return this.$route.path.replace('/', '');
    },
    items(){
      // 使用后端返回的动态菜单
      if (this.userMenus && this.userMenus.length > 0) {
        return this.convertMenus(this.userMenus);
    }
      // 如果没有菜单数据，返回空数组
      return [];
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // 转换后端菜单格式为前端格式
    convertMenus(menus) {
      if (!menus || !Array.isArray(menus)) {
        return [];
      }
      
      return menus.map(menu => {
        // 过滤隐藏菜单
        if (menu.hidden) {
          return null;
        }
        
        let item = {
          index: menu.path ? menu.path.replace('/', '') : String(menu.id),
          title: menu.name,
          icon: menu.icon || ''
        };
        
        // 如果有子菜单
        if (menu.children && menu.children.length > 0) {
          const subs = this.convertMenus(menu.children).filter(s => s !== null);
          if (subs.length > 0) {
            item.subs = subs;
          }
        }
        
        return item;
      }).filter(item => item !== null);
    }
  }
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}
</style>
